import { useTranslation } from "react-i18next";
import type { EmailLog } from "@/lib/emailApi";

export function EmailLogsTable({ logs }: { logs: EmailLog[] }) {
  const { t } = useTranslation();
  if (!logs.length) return <p className="mt-4 text-sm text-muted-foreground" data-testid="admin-email-logs-empty">{t("adminEmail.noLogs")}</p>;
  return (
    <div className="mt-4 overflow-x-auto">
      <table className="w-full text-left text-xs" data-testid="admin-email-logs">
        <thead className="text-[10px] uppercase tracking-widest text-muted-foreground">
          <tr><th className="pb-2 pr-3">{t("adminEmail.when")}</th><th className="pb-2 pr-3">{t("adminEmail.type")}</th><th className="pb-2 pr-3">{t("adminEmail.subjectShort")}</th><th className="pb-2 pr-3 text-right">{t("adminEmail.sentFailed")}</th><th className="pb-2">{t("adminEmail.status")}</th></tr>
        </thead>
        <tbody className="divide-y divide-white/5 text-white">
          {logs.map((l) => (
            <tr key={l.id} data-testid={`admin-email-log-${l.id}`}>
              <td className="py-2 pr-3 whitespace-nowrap text-muted-foreground">{new Date(l.timestamp).toLocaleString()}</td>
              <td className="py-2 pr-3 whitespace-nowrap">{l.template_code ? `${l.template_code} · ${l.source || "MANUAL"}` : l.category} · {l.target_type}{l.recipient_email ? ` · ${l.recipient_email}` : ""}</td>
              <td className="max-w-[220px] truncate py-2 pr-3" title={l.subject}>{l.subject}</td>
              <td className="py-2 pr-3 text-right whitespace-nowrap">{l.sent_count}/{l.recipient_count}{l.failed_count ? <span className="text-red-300"> · {l.failed_count} ✕</span> : null}</td>
              <td className="py-2 font-semibold">{l.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
